@let obs =
  {
    loadImageEagerly: loadImageEagerly$ | async,
  };

<ng-container *ngIf="responsiveBannerData as data; else simple">
  <p *ngIf="data.headline" [innerHTML]="data.headline"></p>

  <picture *ngIf="data?.media | keyvalue as medias">
    <source
      *ngIf="data.media.widescreen as dataMedia"
      [media]="media.widescreen"
      [srcset]="dataMedia.url | sdUrlMedia"
      [attr.width]="dataMedia.width"
      [attr.height]="dataMedia.height"
    />
    <source
      *ngIf="data.media.desktop as dataMedia"
      [media]="media.desktop"
      [srcset]="dataMedia.url | sdUrlMedia"
      [attr.width]="dataMedia.width"
      [attr.height]="dataMedia.height"
    />
    <source
      *ngIf="data.media.tablet as dataMedia"
      [media]="media.tablet"
      [srcset]="dataMedia.url | sdUrlMedia"
      [attr.width]="dataMedia.width"
      [attr.height]="dataMedia.height"
    />
    <source
      *ngIf="data.media.mobile as dataMedia"
      [media]="media.mobile"
      [srcset]="dataMedia.url | sdUrlMedia"
      [attr.width]="dataMedia.width"
      [attr.height]="dataMedia.height"
    />
    <img
      *ngIf="medias[0]?.value as dataMedia"
      [src]="dataMedia.url | sdUrlMedia"
      alt="{{ dataMedia.altText }}"
      [attr.loading]="obs.loadImageEagerly ? 'eager' : 'lazy'"
      [attr.fetchpriority]="obs.loadImageEagerly ? 'high' : 'auto'"
    />
  </picture>

  <p *ngIf="data.content" [innerHTML]="data.content"></p>
</ng-container>
<ng-template #simple>
  <p class="headline" *ngIf="simpleBannerData.headline" [innerHTML]="simpleBannerData.headline"></p>
  <div
    *ngIf="simpleBannerData.media"
    [ngClass]="{ 'ratio-wrapper': !!getHeightRatio(simpleBannerData.media) }"
    [ngStyle]="{
      'max-width': simpleBannerData.media.width && simpleBannerData.media.width + 'px',
    }"
  >
    <div [ngStyle]="{ 'padding-bottom': getHeightRatio(simpleBannerData.media) }"></div>
    <sd-media
      [width]="simpleBannerData.media.width"
      [height]="simpleBannerData.media.height"
      [container]="simpleBannerData.media"
      [loading]="obs.loadImageEagerly ? 'eager' : 'lazy'"
      [fetchpriority]="obs.loadImageEagerly ? 'high' : 'auto'"
    ></sd-media>
  </div>
  <p class="content" *ngIf="simpleBannerData.content" [innerHTML]="simpleBannerData.content"></p>
</ng-template>
